<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Venda</h4>
      </div>
      <div>
        <fg-input
          label="Vending Machine"
          name="vm"
          v-validate="modelValidations.name"
          v-model="model.vm"
          :error="getError('vm')"
        >
          <el-select class="select-default" size="large" placeholder="Selecione" v-model="model.vm">
            <el-option
              v-for="option in machines"
              class="select-danger"
              :value="option.id"
              :label="`${option.location}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input name="mp_uid" label="ID do MercadoPago" v-model="model.mp_uid"></fg-input>

        <fg-input name="protocolo" label="Protocolo de Venda" v-model="model.protocolo"></fg-input>

        <fg-input label="Valor Total" name="total_amount">
          <div class="row">
            <fg-input
              name="total_amount"
              v-validate="modelValidations.price"
              v-model="model.total_amount"
              :error="getError('total_amount')"
              class="col-sm-12"
            >
              <span slot="addonLeft">R$</span>
            </fg-input>
          </div>
        </fg-input>

        <fg-input
          name="status"
          label="Status"
          v-model="model.status"
          v-validate="modelValidations.name"
          :error="getError('status')"
        ></fg-input>

        <fg-input label="Atualizado em">
          <el-date-picker
            v-model="model.updated"
            type="datetime"
            format="dd/MM/yyyy HH:mm:ss"
            placeholder="Selecione"
          ></el-date-picker>
        </fg-input>

        <fg-input label="Cliente">
          <el-select
            class="select-default"
            size="large"
            placeholder="Selecione"
            v-model="model.customer"
            name="vm"
          >
            <el-option
              v-for="option in customers"
              class="select-danger"
              :value="option.id"
              :label="`${option.first_name} ${option.last_name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option, DatePicker } from "element-ui";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker
  },
  created() {
    this.$store.dispatch("customers/list").then(() => {
      this.$store.dispatch("machines/list").then(() => {
        if (this.$route.params.id) {
          this.$store.dispatch("sales/list").then(() => {
            this.model = this.$store.state.sales.sales.find(
              e => e.id == this.$route.params.id
            );
          });
          this.crud = "Editar";
        } else {
          this.crud = "Criar";
        }
      });
    });
  },
  computed: {
    customers() {
      console.log(this.$store.state.customers.customers);
      return this.$store.state.customers.customers;
    },
    machines() {
      console.log(this.$store.state.machines.machines);
      return this.$store.state.machines.machines;
    }
  },
  data() {
    return {
      crud: "Editar",
      model: {
        vm: "",
        mp_uid: "",
        protocolo: "",
        total_amount: "",
        status: "",
        updated: "",
        customer: ""
      },
      modelValidations: {
        name: {
          required: true
        },
        price: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        }
      }
    };
  },
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (!this.model.updated) {
          this.model.updated = Date.now();
        }
        this.model.updated = new Date(this.model.updated).toISOString();
        this.model.total_amount = this.model.total_amount.replace(",", ".");
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("sales/create", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/sales/sales`);
            });
        } else if (isValid && this.crud === "Editar") {
          this.$store
            .dispatch("sales/update", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/sales/sales`);
            });
        }
      });
    }
  }
};
</script>
<style scoped>
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
